var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasBreadcrumb)?_c('Navbar',{staticClass:"navbar has-shadow",staticStyle:{"z-index":"0"},scopedSlots:_vm._u([{key:"start",fn:function(){return [(_vm.isReady)?_c('Breadcrumb',_vm._l((_vm.items),function(ref,index){
var to = ref.to;
var label = ref.label;
return _c('BreadcrumbItem',{key:index,attrs:{"to":to,"active":index + 1 === _vm.items.length}},[_vm._v(_vm._s(_vm.$t(label)))])}),1):_vm._e()]},proxy:true}],null,false,309995568)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }